import { setError  } from "context/auth/authSlice";
import { useDispatch } from "react-redux";

const useAlert = () => { 

    const dispatch  = useDispatch();

    const showAlerts = (errors) =>{
        dispatch(setError(errors));
    }
    
    const hideAlerts = () =>{
        dispatch(setError({
            code:"error",
            msg: null,
            icon: "info",
            type: "alert",
            action:null,
            title:"Dashboard message",
            bgWhite : true
        }));
    }
    
    return {showAlerts, hideAlerts};
}

export default useAlert